<template>
  <div class="work-wrap">
    <div class="work-top-box">
      <div @click="backHandle">返回</div>
      <div class="cell" style="width: calc(100% - 160px); text-align: center">{{ detailData.faultName }}</div>
      <div v-if="detailData.isOverdue" style="color: #f56c6c">{{ detailData.statusName }}（超期）</div>
      <div v-else>{{ detailData.statusName }}</div>
    </div>

    <div class="work-center-box">
      <div class="mt-10" style="overflow-y: auto; height: calc(100% - 70px)">
        <div class="work-card-box">
          <div class="work-title">
            <div class="title cell" style="font-weight: bold">工单基础信息</div>
          </div>
          <div class="work-content-box mt-10">
            <div class="">故障单号：{{ detailData.faultNo }}</div>
            <div class="mt-10">故障类型：{{ detailData.faultTypeName }}</div>
            <div class="mt-10">安装位置：{{ detailData.space }}</div>
            <div class="mt-10">
              设备名称：
              <span v-if="detailData.deviceList.length">
                <span v-for="(item, i) in detailData.deviceList" :key="i">
                  <span style="word-break: break-all; white-space: pre-wrap">{{ item.deviceName }}（{{ item.deviceNo }}）</span>
                  <span v-if="i < detailData.deviceList.length - 1">，</span>
                </span>
              </span>
              <span v-else>—</span>
            </div>
            <div class="mt-10">
              物联卡号：
              <span v-if="detailData.iccIdList.length">
                <span v-for="(item, i) in detailData.iccIdList" :key="i">
                  <span style="word-break: break-all; white-space: pre-wrap">{{ item }}</span>
                  <span v-if="i < detailData.iccIdList.length - 1">，</span>
                </span>
              </span>
              <span v-else>—</span>
            </div>
            <div class="mt-10">紧急程度：{{ detailData.urgencyLevelName }}</div>
            <div class="mt-10">截止日期：{{ detailData.handleEndTime }}</div>
            <div class="mt-10" style="word-break: break-all">故障备注：{{ detailData.faultDescription }}</div>
          </div>
        </div>

        <div class="work-card-box mt-10">
          <div class="work-title">
            <div class="title cell" style="font-weight: bold">工单处理</div>
          </div>
          <div class="work-content-box mt-10">
            <div>
              <span class="is-required">*</span>是否更换设备
              <div>
                <el-radio-group v-model="isReplaceDevice">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="mt-10">
              <span v-if="isReplaceDevice == 1" class="is-required">*</span>新设备ID
              <div>
                <el-input v-model="deviceId" maxlength="50"></el-input>
              </div>
            </div>
            <div class="mt-10">
              <span class="is-required">*</span> 处理图片：
              <div style="display: flex; flex-wrap: wrap" class="mt-5" v-if="!browser">
                <div v-for="(img, index) in imagesList" :key="index" style="position: relative">
                  <el-image style="width: 120px; height: 120px" class="mr-5" :src="img" :preview-src-list="imagesList"></el-image>
                  <div class="img-remove-color">
                    <i @click="removeImage(index)" class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-if="imagesList.length < 5">
                  <el-button @click="chooseImage" icon="el-icon-plus" style="width: 120px; height: 120px; font-size: 22px"></el-button>
                </div>
              </div>
              <!-- 单点登录时在浏览器打开的页面用下面的图片上传，不用微信jssdk方式 -->
              <div style="display: flex; flex-wrap: wrap; width: 100%" class="mt-5" v-else>
                <img-upload :fileSize="20" :limit="5" v-model="fileImageList"></img-upload>
              </div>
            </div>
            <div class="mt-10" style="position: relative">
              <span class="is-required">*</span> 处理备注：
              <el-input type="textarea" class="mt-5" v-model="remark" maxlength="150" rows="5" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入"></el-input>
              <span style="position: absolute; right: 0; font-size: 12px; bottom: -17px; color: #909399">{{ remark.length }}/150</span>
            </div>
          </div>
        </div>

        <div class="detail-deal-btn mt-10" @click="submitHandle">提交工单</div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { initWeChatSDK } from '@/utils/wechat';
import imgUpload from '@/globalComponent/ImgUpload/index.vue';
export default {
  components: {
    imgUpload,
  },
  data() {
    return {
      browser: sessionStorage.getItem('browser'),
      faultImages: [],
      fileList: [],
      imageUrl: '',
      imagesUrl: '',
      file: null,
      remark: '',
      isReplaceDevice: '',
      deviceId: '',
      detailData: {
        iccIdList: [],
        deviceList: [],
      },
      userInfo: {},

      imagesList: [], // 上传的图片
      fileImageList: [],
      serverIds: [],
      filesponseList: [], // 已经上传过的图片
      wxReady: false, // 微信SDK是否已准备就绪
      btn: '',
    };
  },
  mounted() {
    this.initWeChatSDK();
  },
  created() {},
  activated() {
    this.browser = sessionStorage.getItem('browser');
    this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    this.btn = this.$route.query.btn;
    this.serverIds = [];
    this.imagesList = [];
    this.fileImageList = [];
    this.filesponseList = [];
    this.getDetailData();
    this.initWeChatSDK();
  },
  methods: {
    // 初始化微信SDK配置
    async initWeChatSDK() {
      this.wxReady = false;
      try {
        await initWeChatSDK(this.$http, this.$API, ['chooseImage', 'uploadImage', 'getLocalImgData']);
        this.wxReady = true;
      } catch (error) {
        this.wxReady = false;
        console.error('微信SDK初始化失败', error);
      }
    },
    // 详情
    getDetailData() {
      let params = {
        orderId: this.$route.query.id,
      };
      this.$http.get(this.$API.repair_order_detail_with_device_relations, { params }).then((res) => {
        this.detailData = res.data || {};
        if (!this.detailData.infoResponseList) {
          this.detailData.infoResponseList = [];
        }
        this.imagesList = []; // 页面展示图片list
        this.fileImageList = [];
        this.filesponseList = []; // 所有带有http格式的图片list
        /**
         * 页面展示获取infoResponseList第一个的filesponseList
         * filesponseList所有带有http格式的图片list，filesponseList移除图片时在removeImage单独加判断做处理
         * imagesList页面展示图片list，imagesList移除图片时在removeImage处理
         */
        if (this.detailData.infoResponseList.length) {
          this.isReplaceDevice = this.detailData.infoResponseList[0].isReplaceDevice;
          this.deviceId = this.detailData.infoResponseList[0].deviceId;
          if (this.detailData.infoResponseList[0].filesponseList && this.detailData.infoResponseList[0].filesponseList.length) {
            this.filesponseList = this.detailData.infoResponseList[0].filesponseList;
            this.remark = this.detailData.infoResponseList[0].handleRemark || '';
            // fileImageList单点登录时用到的图片信息list
            this.fileImageList = this.detailData.infoResponseList[0].filesponseList || [];
            this.detailData.infoResponseList[0].filesponseList.forEach((item) => {
              this.imagesList.push(item.fileUrl);
            });
          }
        }
      });
    },
    backHandle() {
      this.$router.go(-1);
    },
    submitHandle() {
      if (((this.isReplaceDevice === 1 && this.deviceId) || this.isReplaceDevice === 0) && this.imagesList.length && this.remark) {
        let params = {
          isReplaceDevice: this.isReplaceDevice,
          deviceId: this.deviceId,
          fileRequestList: this.filesponseList,
          handleRemark: this.remark,
          id: this.detailData.infoResponseList.length && this.detailData.infoResponseList[0].id ? this.detailData.infoResponseList[0].id : '',
          mediaList: this.serverIds,
          orderId: this.$route.query.id,
          staffId: this.userInfo.currentStaffId,
          fileRequestList: this.fileImageList,
        };
        console.log('params', params);
        this.$http.post(this.$API.repair_order_process, params).then((res) => {
          if (res.success) {
            // this.$router.push({ path: '/fault/work', query: { btn: this.btn } });
            let url = '/fault/work?btn=' + this.btn;
            window.location.assign(url);
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error('请完善信息');
      }
    },
    async chooseImage() {
      // 微信SDK未就绪时先初始化，失败则提示并终止
      if (!this.wxReady) {
        try {
          await this.initWeChatSDK();
        } catch (error) {
          this.$message.error('微信 SDK 初始化失败，请刷新页面重试');
          return;
        }
      }

      const _this = this;
      wx.chooseImage({
        count: 5 - this.imagesList.length,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          const localIds = res.localIds || [];
          if (!localIds.length) return;
          // _this.serverIds = [];

          // 顺序上传，避免并发导致 serverId 与展示图片错位
          let index = 0;
          const uploadNext = () => {
            if (index >= localIds.length) return;
            const localId = localIds[index];

            const fillLocalImg = () => {
              wx.getLocalImgData({
                localId,
                success: (r) => {
                  let localData = r.localData;
                  // 判断是否包含头部信息
                  if (localData.indexOf('data:image') !== 0) {
                    localData = 'data:image/jpeg;base64,' + localData;
                  }
                  // 替换换行符
                  localData = localData.replace(/\r|\n/g, '');
                  // 如果是 iOS WKWebView，可能需要替换图片类型
                  if (window.__wxjs_is_wkwebview) {
                    localData = localData.replace('data:image/jgp', 'data:image/jpeg');
                  }
                  _this.imagesList.push(localData);
                },
                fail: () => {},
              });
            };

            wx.uploadImage({
              localId,
              isShowProgressTips: 1,
              success: (r) => {
                _this.serverIds.push(r.serverId);
                fillLocalImg();
                index++;
                uploadNext();
              },
              fail: (err) => {
                console.error('图片上传失败', err);
                _this.$message.error('图片上传失败，请重试');
                index++;
                uploadNext();
              },
            });
          };
          uploadNext();
        },
        fail: (err) => {
          console.error('选择图片失败', err);
        },
      });
    },
    // 移除上传图片
    removeImage(i) {
      // this.imagesList 为页面展示的图片list
      this.imagesList.splice(i, 1);
      /**
       * this.filesponseList是从详情获取的图片list
       * 删除图片后移除对应的处理前已上传过的图片（图片链接为http格式的）
       */
      if (this.filesponseList.length && i <= this.filesponseList.length - 1) {
        this.filesponseList.splice(i, 1);
      }
      // 删除图片后移除对应的上传的图片的serverId
      if (i - this.filesponseList.length >= 0) {
        this.serverIds.splice(i - this.filesponseList.length, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.work-wrap {
  height: 100%;
}
.work-top-box {
  display: flex;
  height: 50px;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  font-size: 1.6rem;
  padding: 0 10px;
}
.work-center-box {
  padding: 0 10px;
  height: 100%;
}
.work-card-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  .work-title {
    display: flex;
    .work-status {
      flex: 1 0 100px;
      text-align: right;
      font-size: 1.6rem;
    }
    .title {
      font-size: 1.6rem;
    }
  }
  .work-content-box {
    padding: 10px 10px 20px 10px;
    font-size: 1.6rem;
    border-radius: 6px;
    background-color: #f9fafd;
    .is-required {
      color: #f56c6c;
      position: relative;
      top: 2px;
    }
  }
}
.detail-deal-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  color: #fff;
  background-color: #2f70ff;
  text-align: center;
}
</style>

<style lang="scss">
.img-remove-color {
  position: absolute;
  font-size: 22px;
  width: 22px;
  height: 22px;
  right: 10px;
  bottom: 10px;
  .el-icon-delete {
    color: #fff;
  }
}
</style>
